
// Bootstrap 5.2 components

//import * as Popper from "@popperjs/core"
import { Collapse } from 'bootstrap';
import { Carousel } from 'bootstrap';
import { Modal } from 'bootstrap';
import { Offcanvas } from 'bootstrap';
import { Tab } from 'bootstrap';
import { Tooltip } from 'bootstrap';

window.Tab = Tab;
window.Modal = Modal;
window.Tooltip = Tooltip;

/*
export { default as Alert } from './src/alert.js'
export { default as Button } from './src/button.js'
export { default as Carousel } from './src/carousel.js'
export { default as Collapse } from './src/collapse.js'
export { default as Dropdown } from './src/dropdown.js'
export { default as Modal } from './src/modal.js'
export { default as Offcanvas } from './src/offcanvas.js'
export { default as Popover } from './src/popover.js'
export { default as ScrollSpy } from './src/scrollspy.js'
export { default as Tab } from './src/tab.js'
export { default as Toast } from './src/toast.js'
export { default as Tooltip } from './src/tooltip.js'
*/

// Enable Popover
//const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
//const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))

// Enable Tooltip
document.addEventListener('DOMContentLoaded', function() {
    (function (window, document) {
        document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(function (link) {
            let tooltip = new Tooltip(link, {
                trigger: 'manual'
            });

            let descriptionElement = link.querySelector('.activity-description');

            link.addEventListener('click', function (event) {
                event.stopPropagation();

                // remove others tooltip
                document.querySelectorAll('[data-bs-trigger="manual"]').forEach(function (tips) {
                    if (tips !== link) {
                        let otherTooltip = Tooltip.getInstance(tips);

                        if (otherTooltip) {
                            otherTooltip.hide();
                            tips.classList.remove('show-description');
                        }
                    }
                });

                // display current tooltip
                tooltip.toggle();
                link.classList.add('show-description');
            });

            document.addEventListener('click', function (event) {
                if (!link.contains(event.target)) {
                    tooltip.hide();
                    link.classList.remove('show-description');
                }
            });
        });
    })(window, document);
});

// Fix glitch lazyload+slide on preload
let heroCarousels = Array.prototype.slice.call(
    document.querySelectorAll('.carousel[data-slug]')
);

setTimeout(function() {
    heroCarousels.forEach(function (heroCarousel) {
        heroCarousel.addEventListener('slide.bs.carousel', function (event) {

            const nextImage = event.relatedTarget.querySelector('.hero-img');

            // Image is loaded ? do nothing
            if (nextImage.complete) {
                return;
            }

            // Remove Lazy
            nextImage.removeAttribute('loading');

            // Stop transition
            event.preventDefault();

            // Add listener to load next image
            nextImage.addEventListener('load', function() {
                // re Start transition
                const carouselInstance = Carousel.getInstance(heroCarousel);
                    carouselInstance.next();
            });

        })
    });
}, 200);
